import { themeConstants } from '@paywithextend/components'
import { css } from 'styled-components'

export default css`
  &.UtilityToolbarCreditCardDropdown {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;
    max-height: 38px;
    color: ${themeConstants.colors.cta};
    height: 38px;
    min-height: 38px;


    .CreditCardDropdown {
      min-height: 38px;
      max-height: 38px;
    }

    .textbox-container {
      min-height: 38px;
      max-height: 38px;
      border: none
    }
  }
`